import Page, { ActionPermissionString } from "@src/features/app/Page";
import useUser from "@src/features/app/hooks/useUser";
import { NextPageWithLayout } from "@src/pages/_app";
import { UserType } from "@src/types.generated";
import { ReactElement, useMemo } from "react";
import ManagerHome from "@src/features/home/ManagerHome";
import AdminHome from "@src/features/home/AdminHome";
import MyTrainingListPage from "@src/features/home/MyTrainingListPage";

const HomePage: NextPageWithLayout = () => {
  const { user } = useUser();
  const pageInner = useMemo(() => {
    if (user?.userType === UserType.Manager) return <ManagerHome />;
    if (user?.userType === UserType.Admin) return <AdminHome />;
    return <MyTrainingListPage />;
  }, [user]);
  return pageInner;
};

const requiredActionPermissions: ActionPermissionString[] = [];
const forbiddenUserTypes: UserType[] = [];
HomePage.getLayout = function getLayout(page: ReactElement) {
  return (
    <Page
      requiredActionPermissions={requiredActionPermissions}
      forbiddenUserTypes={forbiddenUserTypes}
    >
      {page}
    </Page>
  );
};

export default HomePage;
